import {
  AfterViewInit,
  Component,
  HostListener,
  OnDestroy,
  OnInit
} from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppInjector } from 'app/services/app-injector.service';
import { AppNavigationService } from 'app/services/app-navigation.service';
import {
  Breakpoint,
  MediaQueryService
} from 'app/services/media-query.service';
import { PageMetaService } from 'app/services/page-meta.service';
import { TrackingService } from 'app/services/tracking.service';
import { GridHeader } from 'app/models/GridHeader';
import { ReportConfig } from './rankings/REPORT_CONFIG';
import { Observable } from 'rxjs';
import { EventBusService } from 'app/services/EventBusService';
import { User } from 'app/models/User';
import { RankingsAnonFormService } from 'app/services/rankings-anon-form.service';

declare let jQuery: any;

@Component({
  selector: 'rankings-page-base',
  template: '',
  styleUrls: []
})
export abstract class RankingsPageBaseComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  protected _router: Router;
  protected _tracking: TrackingService;
  protected _pageMetaService: PageMetaService;
  protected _appNavService: AppNavigationService;
  protected _mediaQueryService: MediaQueryService;
  protected _eventService: EventBusService;
  protected _userService: User;
  protected _rankingsAnonFormService: RankingsAnonFormService;

  protected _title: Title;
  protected _meta: Meta;

  currentConfig: ReportConfig;

  start: number;
  noResult = false;
  loading: boolean;
  loadingData: boolean;

  showLoadMore: boolean;
  showLoadingMore: boolean;
  showAnonEmailUnlockForm: boolean;

  desktop$: Observable<boolean>;
  isDestroyed: boolean;

  constructor(protected _route: ActivatedRoute) {
    this._router = AppInjector.injector.get(Router);
    this._tracking = AppInjector.injector.get(TrackingService);
    this._pageMetaService = AppInjector.injector.get(PageMetaService);
    this._appNavService = AppInjector.injector.get(AppNavigationService);
    this._mediaQueryService = AppInjector.injector.get(MediaQueryService);
    this._eventService = AppInjector.injector.get(EventBusService);
    this._rankingsAnonFormService = AppInjector.injector.get(
      RankingsAnonFormService
    );

    this._title = AppInjector.injector.get(Title);
    this._meta = AppInjector.injector.get(Meta);
    this._userService = AppInjector.injector.get(User);
  }

  ngOnInit(): void {
    this.desktop$ = this._mediaQueryService.gt(Breakpoint.md);
    this.isDestroyed = false;

    this._appNavService.setHideAppBar(true);
    this._tracking.pageTrack();
    this._pageMetaService.setStructuredData(this.getStructuredData());
    this.toggleTableBlur();
  }

  ngOnDestroy(): void {
    this._appNavService.setHideAppBar(false);
    this.isDestroyed = true;
  }

  ngAfterViewInit(): void {}

  abstract loadGridData(isLoadMore?: boolean);

  @HostListener('window:scroll')
  onScroll() {
    if (
      jQuery('.rankings-main-content .right-content') &&
      jQuery('.rankings-main-content .right-content').offset() &&
      jQuery('.right-content.rankings .grid-data') &&
      jQuery('.right-content.rankings .grid-data').offset()
    ) {
      const offsetTop = jQuery('.rankings-main-content .right-content').offset()
        .top;
      const scrollTop = jQuery(window).scrollTop();
      if (scrollTop < offsetTop) {
        jQuery('.rankings-main-content').removeClass('sticky-nav');
      } else {
        jQuery('.rankings-main-content').addClass('sticky-nav');
      }

      const mobilediff =
        jQuery(window).height() +
        (jQuery(window).scrollTop() -
          (jQuery('.rankings-main-content .right-content').offset().top +
            jQuery('.rankings-main-content .right-content').outerHeight()));
      if (mobilediff > 0) {
        jQuery('.rankings-main-content .side-navigation').css(
          'margin-bottom',
          mobilediff + 'px'
        );
      } else {
        jQuery('.rankings-main-content .side-navigation').css(
          'margin-bottom',
          '0px'
        );
      }

      const iscrollTop = jQuery(document).scrollTop();
      const ioffsetTop = jQuery('.right-content.rankings .grid-data').offset()
        .top;
      const iheaderHeight = jQuery(
        '.right-content.rankings .grid-header'
      ).outerHeight();

      if (iscrollTop >= ioffsetTop - iheaderHeight) {
        jQuery('.right-content.rankings').addClass('sticky');
      } else {
        jQuery('.right-content.rankings').removeClass('sticky');
      }
    }
  }

  getStructuredData() {
    return {
      '@context': 'https://schema.org',
      publisher: {
        '@type': 'Organization',
        name: 'Pixalate'
      }
    };
  }

  get isEnterprise(): boolean {
    return this._userService.isEnterprise();
  }

  get isFreemium(): boolean {
    return this._userService.isFreemium();
  }

  get isAnonymous(): boolean {
    return this._userService.isAnonymous();
  }

  loadMore() {
    this.loadGridData(true);
  }

  toggleSort(selectedGridHeader: GridHeader) {
    if (
      this.currentConfig.sortable &&
      selectedGridHeader.sortColumnKey &&
      !this.loadingData
    ) {
      this.currentConfig.gridHeaders.forEach(gridHeader => {
        if (gridHeader.key === selectedGridHeader.key) {
          const sort = gridHeader.sort;
          if (sort === '' || sort === 'sort-desc') {
            gridHeader.sort = 'sort-asc';
          } else if (sort === 'sort-asc') {
            gridHeader.sort = 'sort-desc';
          }
        } else {
          gridHeader.sort = '';
        }
      });
      this.start = 0;
      this.loadGridData();
    }
  }

  toggleTableBlur() {
    var hasSubmittedAnonEmail = this._rankingsAnonFormService.isFormSubmitted();
    this.showAnonEmailUnlockForm = this.isAnonymous && !hasSubmittedAnonEmail;
  }
}
